import type { BusinessType } from '#packages/siteGlobalData';
import type { ImageDetails } from '@wix/editor-site-generator';

import type { PanelTypes } from './constants';

export interface QuestionnaireParams {
  businessType: BusinessType;
  businessName: string;
  businessDescription: string;
}

export interface QuestionnaireMessages {
  businessType: string;
  businessName: string;
  businessDescription: string;
}

export interface OnInjectionSuccessFnParams {
  requestParams: QuestionnaireParams;
  responseParams: SuccessSiteInjectionResponse;
  requestStartTime: number;
  isAutosubmitFlow: boolean;
  actionOrigin: string;
  isPageByPageFlow?: boolean;
  requestEndTime?: number;
}

export interface QuestionnairePanelOwnProps {
  onClose: (origin?: string) => void;
  onSubmit: (params: QuestionnaireParams) => void;
  panelType: PanelTypes;
}

export interface QuestionnairePanelStateProps {
  initialBusinessType: BusinessType;
  initialBusinessName: string;
}

export interface StateProps {
  businessType: BusinessType;
  businessName: string;
}

export interface ErrorData {
  originalError: {
    errorType: string;
    extras: {
      completionText: object;
      pageId: string;
      businessType: string;
      businessName: string;
      additionalInformation: string;
      currentPromptsVersion?: string;
      currentGptParamsVersion?: string;
    };
  };
  contentServerError?: {
    status: string;
    message: string;
    currentPromptsVersion: string;
    currentGptParamsVersion: string;
  };
  tokenUsage: TokenUsage[];
}

export interface DispatchProps {
  onClose: (origin?: string) => void;
  onSubmit: (
    params: QuestionnaireParams,
    isAutosubmitFlow: boolean,
    actionOrigin: string,
    onSuccess: (params: OnInjectionSuccessFnParams) => void,
    onFailure: (errorData: ErrorData) => void,
  ) => void;
  highlightLeftBarMenu: () => void;
  unHighlightLeftBarMenu: () => void;
  getParentId: (id: string) => any;
  getAdditionalBIData: (componentId: string) => any;
  isFunnelDataApplicable: (onSuccess: (result: boolean) => void) => void;
  getDescriptionFromFunnel: (onSuccess: (result: string) => void) => void;
  showNotification: (message: string) => void;
}

export interface TokenUsage {
  prompt_tokens: number;
  completion_tokens: number;
  total_tokens: number;
}

export interface ErrorBIData {
  params: QuestionnaireParams;
  currentGptParamsVersion: string;
  currentPromptsVersion: string;
  tokenUsage: TokenUsage[];
}

export interface FlattenedObject {
  [key: string]: any;
}

export interface SuccessPageInjectionResponse {
  suggestionResults: {
    outline: object;
    originalOutline: object;
    idMap: { [key: string]: string };
    completionMetadata: {
      gptParamsVersion: string;
      promptsVersion: string;
      tokenUsage: TokenUsage[];
    };
  };
}

export interface SuccessSiteInjectionResponse
  extends Array<{
    pageId: string;
    pageSuggestion?: {
      outline: object;
      originalOutline: object;
      idMap: { [key: string]: string };
      completionMetadata: {
        gptParamsVersion: string;
        promptsVersion: string;
        tokenUsage: TokenUsage[];
      };
    };
  }> {}

export enum InjectionStrategy {
  PHOTO = 'photo',
  BACKGROUND = 'background',
}

export type ImageDetailsTyped = ImageDetails & {
  injectionStrategy?: InjectionStrategy;
};

export type ImagesMapTyped = Map<string, ImageDetailsTyped>;
